// TODO: native review — German translations are machine-generated.
export default {
  header: {
    hello: 'Hallo {name}',
    connected: 'Verbunden',
    disconnected: 'Getrennt',
    connectionWarning:
      'Verbindungsprobleme erkannt - einige Funktionen funktionieren möglicherweise nicht richtig',
    conversationId: 'Konversations-ID:',
    language: 'Sprache:',
    notAvailable: 'Nicht verfügbar',
    connectionStatus: 'Verbindungsstatus:',
    genesysConnected: 'Verbunden',
    genesysDisconnected: 'Getrennt',
    allConnectionsActive: 'Alle Verbindungen aktiv',
    connectionIssues: 'Verbindungsprobleme: {issues}',
  },
  app: {
    loggingIn: 'Anmeldung…',
    pleaseWait: 'Bitte warten.',
    loginFailed: 'Anmeldung fehlgeschlagen',
    retry: 'Erneut versuchen',
    login: 'Anmelden',
    notAuthenticated: 'Nicht authentifiziert',
    errorProcessing: 'Fehler beim Verarbeiten der Nachricht',
    dismiss: 'Schließen',
    readyToAssist: 'Bereit, bei neuen Kundennachrichten zu helfen',
    connectionFailed: 'Verbindung zum Service konnte nicht hergestellt werden',
    processing: 'Kundennachricht wird verarbeitet...',
    sending: 'An KI-Service wird gesendet...',
    generating: 'Pete erstellt Antwort...',
    working: 'Verarbeiten...',
    generatingShort: 'Generieren...',
    summary: 'Zusammenfassung',
    activityLog: 'Aktivität',
  },
  middleware: {
    ready: 'Bereit',
    ingesting: 'Gespräch wird aktualisiert…',
    waiting: 'Warten auf nächste Nachricht…',
    agent_context: 'Agentennachricht gespeichert',
    checking: 'Prüfen / Stille erkannt…',
    generating: 'Pete erstellt Antwort…',
    retrying: 'Pete versucht es erneut (Versuch {attempt}/{max})…',
    responded: 'Antwort fertig',
    summarizing: 'Zusammenfassung wird erstellt…',
    summarized: 'Zusammenfassung fertig',
    failed: 'Fehlgeschlagen — erneuter Versuch möglicherweise nötig',
    ended: 'Gesprächsende erkannt',
    resumed: 'Gespräch fortgesetzt — Auswahl erforderlich',
  },
  resume: {
    title: 'Gespräch fortgesetzt',
    prompt: 'Dieser Kunde hatte bereits ein Gespräch. Wie möchten Sie fortfahren?',
    previousSummary: 'Zusammenfassung des vorherigen Gesprächs',
    generatingSummary: 'Zusammenfassung wird erstellt...',
    noSummary: 'Keine Zusammenfassung verfügbar.',
    continue: 'Fortfahren',
    new: 'Neues Gespräch',
    newWithSummary: 'Neu + Zusammenfassung als Kontext',
  },
  response: {
    originalMessage: 'Ursprüngliche Nachricht',
    agentResponseTitle: 'Antwort für Agenten',
    saveAndTranslate: 'Speichern & Übersetzen',
    translating: 'Übersetzung läuft...',
    edit: 'Bearbeiten',
    cancel: 'Abbrechen',
    translationPlaceholder: 'Deutsche Übersetzung eingeben...',
    customerReply: 'Antwort in der Sprache des Kunden',
    send: 'Senden',
    sending: 'Wird gesendet...',
    sentSuccessfully: 'Erfolgreich gesendet',
    sendFailed: 'Senden fehlgeschlagen',
    waitingForMessages: 'Warten auf Kundennachrichten',
    waitingForMessagesHint:
      'KI-Unterstützung erscheint hier, wenn Kunden Nachrichten senden',
    suggestions: 'Vorschläge',
  },
  summary: {
    title: 'Zusammenfassung',
    generating: 'Zusammenfassung wird erstellt...',
    error: 'Fehler beim Erstellen der Zusammenfassung',
    close: 'Schließen',
    copy: 'Zusammenfassung kopieren',
    copied: 'Kopiert!',
  },
  articles: {
    related: 'Verwandte Artikel',
    viewArticle: 'Artikel ansehen',
  },
  product: {
    info: 'Produktinformation',
  },
};
